var map = {
	"./ALL_DISABLED.svg": 9623,
	"./ALL_ENABLED.svg": 51776,
	"./Apple_logo.svg": 5888,
	"./Apple_logo_grey.svg": 16969,
	"./CUSTOM.svg": 10559,
	"./ONLY_FORECASTS.svg": 33326,
	"./add.svg": 14780,
	"./ampliar.svg": 46596,
	"./android.svg": 22036,
	"./apuestas.svg": 75906,
	"./back.svg": 37911,
	"./ben-1.svg": 10906,
	"./ben-2.svg": 52572,
	"./ben-3.svg": 70687,
	"./bookies/1XBet.svg": 65412,
	"./bookies/888Sport.svg": 95528,
	"./bookies/Bet365.svg": 80274,
	"./bookies/BetfairExchange.svg": 18872,
	"./bookies/Betfred.svg": 43722,
	"./bookies/Bethard.svg": 50154,
	"./bookies/Betway.svg": 42663,
	"./bookies/Bwin.svg": 17995,
	"./bookies/Caliente.svg": 21080,
	"./bookies/Codere.svg": 66246,
	"./bookies/Interwetten.svg": 4730,
	"./bookies/KirolBet.svg": 78358,
	"./bookies/LeoVegas.svg": 82099,
	"./bookies/LondonBettingShop.svg": 69650,
	"./bookies/Marathon.svg": 63929,
	"./bookies/Merkur.svg": 10300,
	"./bookies/Mondobets.svg": 66811,
	"./bookies/PinnacleSports.svg": 78158,
	"./bookies/Pokerstars.svg": 16583,
	"./bookies/Retabet.svg": 21133,
	"./bookies/Sportium.svg": 41186,
	"./bookies/StarVegas.svg": 26868,
	"./bookies/WilliamHill.svg": 63771,
	"./bookies/Winamax.svg": 81294,
	"./boost-arrow.svg": 20113,
	"./boost-fire.svg": 51837,
	"./boost-low.svg": 18488,
	"./boost-max.svg": 30203,
	"./boost-mid.svg": 10186,
	"./card.svg": 44479,
	"./chat.svg": 15166,
	"./check.svg": 90706,
	"./close.svg": 50420,
	"./coin.svg": 39089,
	"./coins.svg": 65835,
	"./countries/ad.svg": 18382,
	"./countries/ae.svg": 78073,
	"./countries/af.svg": 93933,
	"./countries/ag.svg": 19034,
	"./countries/al.svg": 52632,
	"./countries/am.svg": 25193,
	"./countries/ao.svg": 92466,
	"./countries/ar.svg": 64523,
	"./countries/at.svg": 43624,
	"./countries/au.svg": 43390,
	"./countries/az.svg": 20008,
	"./countries/ba.svg": 3722,
	"./countries/bb.svg": 72674,
	"./countries/bd.svg": 35989,
	"./countries/be.svg": 2538,
	"./countries/bf.svg": 32702,
	"./countries/bg.svg": 94407,
	"./countries/bh.svg": 29167,
	"./countries/bi.svg": 76307,
	"./countries/bj.svg": 36667,
	"./countries/bn.svg": 26005,
	"./countries/bo.svg": 48270,
	"./countries/br.svg": 68663,
	"./countries/bs.svg": 79640,
	"./countries/bt.svg": 75001,
	"./countries/bw.svg": 21294,
	"./countries/by.svg": 63113,
	"./countries/bz.svg": 32081,
	"./countries/ca.svg": 14699,
	"./countries/cd.svg": 47782,
	"./countries/cf.svg": 40983,
	"./countries/cg.svg": 55682,
	"./countries/ch.svg": 83341,
	"./countries/ci.svg": 12684,
	"./countries/cl.svg": 5022,
	"./countries/cm.svg": 7761,
	"./countries/cn.svg": 75560,
	"./countries/co.svg": 76386,
	"./countries/cr.svg": 47598,
	"./countries/cu.svg": 37307,
	"./countries/cv.svg": 84450,
	"./countries/cy.svg": 68312,
	"./countries/cz.svg": 91882,
	"./countries/de.svg": 75519,
	"./countries/dj.svg": 68969,
	"./countries/dk.svg": 93352,
	"./countries/dm.svg": 91110,
	"./countries/do.svg": 78109,
	"./countries/dz.svg": 85087,
	"./countries/ec.svg": 96366,
	"./countries/ee.svg": 2832,
	"./countries/eg.svg": 63231,
	"./countries/er.svg": 9451,
	"./countries/es.svg": 39500,
	"./countries/et.svg": 49809,
	"./countries/fi.svg": 13175,
	"./countries/fj.svg": 60145,
	"./countries/fm.svg": 60754,
	"./countries/fr.svg": 2430,
	"./countries/ga.svg": 61666,
	"./countries/gb.svg": 69522,
	"./countries/gd.svg": 26007,
	"./countries/ge.svg": 75238,
	"./countries/generic.svg": 4088,
	"./countries/gh.svg": 48012,
	"./countries/gm.svg": 16261,
	"./countries/gq.svg": 77981,
	"./countries/gr.svg": 92839,
	"./countries/gt.svg": 78826,
	"./countries/gw.svg": 14694,
	"./countries/gy.svg": 37802,
	"./countries/hn.svg": 58302,
	"./countries/hr.svg": 15463,
	"./countries/ht.svg": 71385,
	"./countries/hu.svg": 70282,
	"./countries/id.svg": 53405,
	"./countries/ie.svg": 23262,
	"./countries/il.svg": 27553,
	"./countries/in.svg": 91511,
	"./countries/iq.svg": 22065,
	"./countries/ir.svg": 80878,
	"./countries/is.svg": 96225,
	"./countries/it.svg": 32410,
	"./countries/jm.svg": 32995,
	"./countries/jo.svg": 61441,
	"./countries/jp.svg": 34734,
	"./countries/ke.svg": 27673,
	"./countries/kg.svg": 55431,
	"./countries/kh.svg": 665,
	"./countries/ki.svg": 29426,
	"./countries/km.svg": 13589,
	"./countries/kn.svg": 58910,
	"./countries/kp.svg": 14874,
	"./countries/kr.svg": 62075,
	"./countries/kw.svg": 11438,
	"./countries/kz.svg": 76422,
	"./countries/l.svg": 9002,
	"./countries/la.svg": 91300,
	"./countries/lb.svg": 51317,
	"./countries/lc.svg": 49299,
	"./countries/li.svg": 48286,
	"./countries/lk.svg": 59065,
	"./countries/lr.svg": 25296,
	"./countries/ls.svg": 42775,
	"./countries/lt.svg": 12271,
	"./countries/lv.svg": 98703,
	"./countries/ly.svg": 85932,
	"./countries/ma.svg": 92465,
	"./countries/mc.svg": 6465,
	"./countries/md.svg": 41873,
	"./countries/me.svg": 62759,
	"./countries/mg.svg": 2275,
	"./countries/mh.svg": 16929,
	"./countries/mk.svg": 65483,
	"./countries/ml.svg": 52891,
	"./countries/mm.svg": 37898,
	"./countries/mr.svg": 76113,
	"./countries/mt.svg": 22717,
	"./countries/mu.svg": 69228,
	"./countries/mv.svg": 62437,
	"./countries/mw.svg": 25648,
	"./countries/mx.svg": 70962,
	"./countries/my.svg": 23704,
	"./countries/mz.svg": 55893,
	"./countries/na.svg": 65033,
	"./countries/ne.svg": 72256,
	"./countries/ng.svg": 74737,
	"./countries/ni.svg": 82903,
	"./countries/nl.svg": 8437,
	"./countries/no.svg": 48599,
	"./countries/np.svg": 27612,
	"./countries/nr.svg": 95007,
	"./countries/nz.svg": 36893,
	"./countries/om.svg": 45632,
	"./countries/pa.svg": 28148,
	"./countries/pe.svg": 21646,
	"./countries/pg.svg": 26180,
	"./countries/ph.svg": 91965,
	"./countries/pl.svg": 87727,
	"./countries/pt.svg": 91676,
	"./countries/pw.svg": 21927,
	"./countries/py.svg": 56446,
	"./countries/qa.svg": 19149,
	"./countries/ro.svg": 94761,
	"./countries/rs.svg": 37300,
	"./countries/ru.svg": 64118,
	"./countries/rw.svg": 40589,
	"./countries/sa.svg": 90736,
	"./countries/sb.svg": 86766,
	"./countries/sc.svg": 13891,
	"./countries/sd.svg": 43016,
	"./countries/se.svg": 54571,
	"./countries/sg.svg": 7600,
	"./countries/si.svg": 30437,
	"./countries/sk.svg": 95700,
	"./countries/sl.svg": 30209,
	"./countries/sm.svg": 76086,
	"./countries/sn.svg": 64229,
	"./countries/so.svg": 64453,
	"./countries/sr.svg": 844,
	"./countries/ss.svg": 24784,
	"./countries/st.svg": 79312,
	"./countries/sv.svg": 31525,
	"./countries/sy.svg": 85847,
	"./countries/sz.svg": 63191,
	"./countries/td.svg": 58885,
	"./countries/tg.svg": 89211,
	"./countries/th.svg": 83747,
	"./countries/tj.svg": 49233,
	"./countries/tl.svg": 97173,
	"./countries/tm.svg": 80629,
	"./countries/tn.svg": 51337,
	"./countries/to.svg": 7763,
	"./countries/tr.svg": 5323,
	"./countries/tt.svg": 69820,
	"./countries/tv.svg": 85156,
	"./countries/tw.svg": 54864,
	"./countries/tz.svg": 42835,
	"./countries/ua.svg": 21239,
	"./countries/ug.svg": 26127,
	"./countries/us.svg": 69248,
	"./countries/uy.svg": 22920,
	"./countries/uz.svg": 25952,
	"./countries/va.svg": 11925,
	"./countries/vc.svg": 43498,
	"./countries/ve.svg": 88791,
	"./countries/vn.svg": 32224,
	"./countries/vu.svg": 5857,
	"./countries/ws.svg": 71582,
	"./countries/ye.svg": 61124,
	"./countries/za.svg": 68219,
	"./countries/zm.svg": 30966,
	"./countries/zw.svg": 76270,
	"./dashboard/Premium.svg": 71015,
	"./dashboard/icons-premium.svg": 83119,
	"./dashboard/icons-token.svg": 93685,
	"./delete.svg": 82539,
	"./footer/Apple_Store_Logo.svg": 42641,
	"./footer/Google_Play_Logo.svg": 21708,
	"./footer/ic-instagram.svg": 917,
	"./footer/ic-twitter.svg": 52217,
	"./footer/ic-youtube.svg": 19003,
	"./ic-add.svg": 75904,
	"./ic-close.svg": 67918,
	"./ic-headphones.svg": 87531,
	"./ic-instagram.svg": 4440,
	"./ic-radiobutton-active.svg": 67930,
	"./ic-radiobutton-inactive.svg": 31249,
	"./ic-telegram.svg": 35285,
	"./ic-twitter.svg": 12536,
	"./ic-video.svg": 29285,
	"./ic_avatar_default.svg": 81906,
	"./ic_tipster_default.svg": 68583,
	"./icon-coupon.svg": 40558,
	"./icons-app-bar-back.svg": 96154,
	"./icons-bank-account.svg": 25565,
	"./icons-coupon.svg": 21577,
	"./icons-follow-small.svg": 13798,
	"./icons-lock.svg": 99605,
	"./icons-nav-bar-back.svg": 83889,
	"./icons-paypal-small.svg": 880,
	"./icons-people.svg": 9678,
	"./icons-tips.svg": 44943,
	"./icons-vote.svg": 30202,
	"./icons-web-income.svg": 15011,
	"./lock.svg": 73914,
	"./logo.svg": 83190,
	"./master-card-light.svg": 92772,
	"./noticia.svg": 52161,
	"./path.svg": 68044,
	"./path2.svg": 79755,
	"./paypal-bnw.svg": 2423,
	"./paypal-light.svg": 78839,
	"./paypal.svg": 74539,
	"./person.svg": 40340,
	"./play.svg": 5590,
	"./publish-tipster.svg": 68612,
	"./sales/premium.svg": 80376,
	"./sales/tip.svg": 59581,
	"./settings.svg": 20677,
	"./shop/apple.svg": 65476,
	"./shop/facebook.svg": 10575,
	"./shop/shape.svg": 42768,
	"./show.svg": 4837,
	"./sports/AMERICAN-FOOTBALL.svg": 38931,
	"./sports/BASEBALL.svg": 3085,
	"./sports/BASKETBALL.svg": 32114,
	"./sports/BOXING.svg": 34685,
	"./sports/CYCLING.svg": 71447,
	"./sports/DARTS.svg": 99134,
	"./sports/ESPORTS.svg": 33365,
	"./sports/FORMULA_1.svg": 62107,
	"./sports/FUTSAL.svg": 7622,
	"./sports/GOLF.svg": 12689,
	"./sports/GREYHOUND_RACING.svg": 90117,
	"./sports/HANDBALL.svg": 66141,
	"./sports/HORSE_RACING.svg": 22317,
	"./sports/ICE-HOCKEY.svg": 75946,
	"./sports/INDOOR_SOCCER.svg": 13277,
	"./sports/MARTIAL-ARTS.svg": 10965,
	"./sports/MOTOR.svg": 85328,
	"./sports/OTHER.svg": 55599,
	"./sports/PADDLE.svg": 94711,
	"./sports/RUGBY-LEAGUE.svg": 37358,
	"./sports/RUGBY-UNION.svg": 82418,
	"./sports/SNOOKER.svg": 8843,
	"./sports/SOCCER.svg": 16299,
	"./sports/SQUASH.svg": 15801,
	"./sports/TABLE-TENNIS.svg": 58314,
	"./sports/TENNIS.svg": 77185,
	"./sports/VOLLEYBALL.svg": 55367,
	"./sports/WINTER_SPORTS.svg": 5037,
	"./stats.svg": 84079,
	"./tipPublish/GENERAL.svg": 93803,
	"./tips/bolt.svg": 65447,
	"./tips/tip-result-dot-canceled.svg": 37485,
	"./tips/tip-result-dot-lost.svg": 72658,
	"./tips/tip-result-dot-not-started.svg": 85345,
	"./tips/tip-result-dot-null.svg": 97967,
	"./tips/tip-result-dot-won.svg": 15868,
	"./tipster-small-logo.svg": 43677,
	"./tipsters.svg": 70018,
	"./transactions/HISTORIC_TIP_SALE.svg": 56078,
	"./transactions/PAYOUT.svg": 10702,
	"./transactions/PREMIUM_SALE.svg": 86516,
	"./transactions/PREMIUM_SALE_REFUND.svg": 10731,
	"./transactions/PRODUCT_SALE.svg": 81954,
	"./transactions/PRODUCT_SALE_REFUND.svg": 90648,
	"./transactions/REFERRAL_RECEIVED.svg": 51365,
	"./transactions/TIER_PREMIUM_SALE.svg": 11252,
	"./transactions/TIER_PREMIUM_SALE_REFUND.svg": 71223,
	"./transactions/TIP_COUPON_SALE.svg": 61451,
	"./transactions/TIP_SALE.svg": 85941,
	"./transactions/TIP_SALE_REFUND.svg": 56016,
	"./transactions/TRANSFER_RECEIVED.svg": 16308,
	"./transactions/generic.svg": 8201,
	"./visa-light.svg": 54946,
	"./web-icons-card.svg": 65244,
	"./world-cup-logo.svg": 32647
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87254;